module.exports = __webpack_public_path__ + "static/img/arrow_right.ae5a36e6.svg";